import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import SaveAndPublishButton from './SaveAndPublishButton';

interface FormActionButtonsProps {
  onBack: () => void;
  onRevert: () => void;
  onSubmit: () => void;
  isFormDirty: boolean;
  backButtonText: string;
  revertButtonText?: string;
}

export const FormActionButtons: React.FC<FormActionButtonsProps> = ({
  onBack,
  onRevert,
  onSubmit,
  isFormDirty,
  backButtonText,
  revertButtonText
}) => {
  const { t } = useTranslation();

  return (
    <Row className="mb-5">
      <Col md={4}>
        <Button 
          variant="secondary" 
          className="font-weight-bold" 
          onClick={onBack}
        >
          <FontAwesomeIcon className="mr-2" icon={["fas", "reply-all"]}/>
          {backButtonText}
        </Button>
      </Col>
      <Col md={8}>
        <div className="float-right">
          {onRevert && (
            <Button 
              variant="outline-primary font-weight-bold" 
              className="mr-3" 
              onClick={onRevert}
            >
              <FontAwesomeIcon className="mr-2" icon={["fas", "trash-alt"]}/>
              {revertButtonText || t("manageVenuesScreen.revert")}
            </Button>
          )}
          <SaveAndPublishButton onClick={onSubmit} />
        </div>
      </Col>
    </Row>
  );
}; 